import React from 'react';
import {RoutePermittedRole} from '../../../shared/constants/AppEnums';
import CreateCampaign from './mailing-campaigns/create-campaign';

const MailingCampaigns = React.lazy(() => import('./mailing-campaigns'));
const Subscribers = React.lazy(() => import('./subscribers'));

export const promotionsNewsLetterConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/promotions.news-letter/mailing-campaigns',
    element: <MailingCampaigns />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/promotions.news-letter/mailing-campaigns/create',
    element: <CreateCampaign />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/promotions.news-letter/mailing-campaigns/edit/:id',
    element: <CreateCampaign />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/promotions.news-letter/subscribers',
    element: <Subscribers />,
  },
];
